/* Keep the existing Product offer aligned with the mattress configurator. */
(function (root) {
  'use strict';

  function updateProductOffer(variant) {
    if (!variant || !Number.isSafeInteger(variant.id) ||
        !Number.isSafeInteger(variant.price) || variant.price < 0 ||
        typeof variant.available !== 'boolean') return;

    var element = document.querySelector('script[data-mm-product-schema]');
    if (!element) return;

    try {
      var product = JSON.parse(element.textContent);
      if (product['@type'] !== 'Product' || !product.offers ||
          product.offers['@type'] !== 'Offer') return;
      var url = new URL(product.offers.url);
      url.searchParams.set('variant', String(variant.id));
      product.offers.url = url.href;
      product.offers.price = variant.price / 100;
      product.offers.availability = variant.available
        ? 'https://schema.org/InStock'
        : 'https://schema.org/OutOfStock';
      if (variant.sku) product.sku = variant.sku;
      else delete product.sku;
      element.textContent = JSON.stringify(product);
    } catch (_) {
      // Structured data must never interrupt the shopping experience.
    }
  }

  root.mmUpdateProductOffer = updateProductOffer;
})(window);
